import { useState } from "react";
import { format } from "date-fns";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";

import { getLabel } from "../../tools/Dictionary";

const AdminProcessPublish = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const Process = props.Process;
  const PublishProcess = props.Process.publishProcess;
  const OnCloseModal = props.OnCloseModal;
  const OnPublish = props.OnPublish;

  //State
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  const onClickPublish = async() => {

    try
    {


      setLoading(true);

      await OnPublish(Process._id);


      setLoading(false);

      setAlert({
        Title: getLabel("AdminProcessPublish", "Process Published"),
        Message: getLabel("AdminProcessPublish", "The process has been successfully published."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: OnCloseModal,
        Display: true
      });



    } catch (err)
    {

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });


    }
    
  };

  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px", minHeight: "300px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("AdminProcessPublish", "Publish")}
        </div>
        <div className="page_modal_body_cont" style={{minHeight: "250px"}}>
          <div className="page_modal_body_row_center">
            <div className="page_modal_body_row_center_title">
              {getLabel("AdminProcessPublish", "Published Version")} 
            </div>
            {PublishProcess ? (
              <div className="page_modal_body_col_center_value">
                <span style={{ color: "#5ba644" }}>{format(PublishProcess.updatedAt, 'yyyy-MM-dd HH:mm')}</span>&nbsp; by &nbsp;
                <span style={{ color: "#0076a5" }}>{PublishProcess.updatedBy ? PublishProcess.updatedBy.firstName + " " + PublishProcess.updatedBy.lastName : "-"}</span>
              </div>
            ):(
              <div className="page_modal_body_col_center_value">
                  {getLabel("AdminProcessPublish", "Not Published")} 
              </div>
            )}
          </div>
          <div className="page_modal_body_row_center">
            <div className="page_modal_body_row_center_title">
                {getLabel("AdminProcessPublish", "Current Version")}
            </div>
            <div className="page_modal_body_col_center_value">
              <span style={{ color: "#5ba644" }}>{format(Process.updatedAt, 'yyyy-MM-dd HH:mm')}</span>&nbsp; by &nbsp;
              <span style={{ color: "#0076a5" }}>{Process.updatedBy ? Process.updatedBy.firstName + " " + Process.updatedBy.lastName : "-"}</span>
            </div>
          </div>
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Cancel")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          {Access.canWrite &&
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("AdminProcessPublish", "Publish")}
              style={{ maxWidth: "200px", backgroundColor: "#5ba644" }}
              onClick={(loading) ? undefined : onClickPublish}
              disabled={loading}
            />
          }
        </div>
      </div>
    </div>
  );

};

export default AdminProcessPublish